"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Crop {
    constructor(obj) {
        this.id = obj.id || -1;
        this.name = obj.name || '-';
        this.color = obj.color || '#000000';
        this.icon = obj.icon || '-';
    }
    getSRC(type) {
        var _a;
        let fixType = (type.length > 0) ? type : 'background';
        return (_a = this.icon) !== null && _a !== void 0 ? _a : `/crop/pic/${type}/${this.icon}/Soil`;
    }
}
exports.default = Crop;
